import React, { useEffect, useState } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useClient } from '../context/ClientContext'
import Loader from './ui/loader'

/**
 * Protected Route Component
 * Handles route protection and authentication checks
 *
 * @param {boolean} requireAuth - If true, only authenticated users can access (default: true)
 * @param {boolean} isPublicOnly - If true, only unauthenticated users can access (e.g., signin, signup)
 */
const ProtectedRoute = ({
  children,
  requireAuth = true,
  isPublicOnly = false,
}) => {
  const { loading, checkSession, isAuthenticated: clientIsAuthenticated } = useClient()
  const [checking, setChecking] = useState(true)
  const [isAuthenticated, setIsAuthenticated] = useState(false)
  const location = useLocation()
  const { tenanturlname } = useParams()

  // Verify authentication with backend on mount
  // useEffect(() => {
  //   const verifyAuth = async () => {
  //     try {
  //       const authResult = await checkSession()
  //       setIsAuthenticated(authResult)
  //     } catch (error) {
  //       console.error('ProtectedRoute - Error checking session:', error)
  //       setIsAuthenticated(false)
  //     } finally {
  //       setChecking(false)
  //     }
  //   }

  //   verifyAuth()
  // }, [checkSession])

  // Show loading state while checking auth
  if (loading) {
    return (
      <Loader 
        fullscreen 
        label="認証中..." 
        size="xl"
      />
    )
  }

  // Handle public-only routes (signin, signup, forgot password, etc.)
  if (isPublicOnly && clientIsAuthenticated) {
    // Check if there's a pending spin email redirect
    const spinRedirect = sessionStorage.getItem('spin_email_redirect')
    let redirectTo = tenanturlname ? `/${tenanturlname}` : '/'
    if (spinRedirect) {
      sessionStorage.removeItem('spin_email_redirect')
      redirectTo = tenanturlname ? `/${tenanturlname}/myprofile?tab=cashback` : '/'
    }
    return <Navigate to={redirectTo} replace />
  }

  // Handle protected routes (requires authentication)
  if (requireAuth && !clientIsAuthenticated) {
    // Save the location they were trying to access and redirect to signin
    const redirectTo = tenanturlname
      ? `/${tenanturlname}/signin`
      : '/dev-demo/signin'
    return <Navigate to={redirectTo} state={{ from: location }} replace />
  }

  return children
}

export default ProtectedRoute
